module.exports = __webpack_public_path__ + "static/media/Ubuntu-Bold.4ce7f4b1.woff2";